module.exports = __webpack_public_path__ + "img/ipaymu.9ab1b392.png";